import { render, staticRenderFns } from "./EditarVideos.vue?vue&type=template&id=5f3df7a0&scoped=true&"
import script from "./EditarVideos.vue?vue&type=script&lang=js&"
export * from "./EditarVideos.vue?vue&type=script&lang=js&"
import style0 from "./EditarVideos.vue?vue&type=style&index=0&id=5f3df7a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3df7a0",
  null
  
)

export default component.exports